import {observer} from "mobx-react";
import Accordion from "../../../models/Accordion";
import {Box, Card, CardContent, CardMedia, Chip, Fade, Typography, useTheme} from "@mui/material";
import React, {useEffect, useState} from "react";
import './AccordionOverviewCard.css'
import {useNavigate} from "react-router-dom";
import {EntityStatus} from "../../../models/EntityStatus";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import {IconWithTooltip} from "../../Misc/IconWithToolbar/IconWithTooltip";
import ShareIcon from '@mui/icons-material/Share';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import {useStore} from "../../../stores/Store";
import BrandIcon from "../../Misc/BrandIcon/BrandIcon";

interface AccordionOverviewCardProps {
    accordion: Accordion,
    image: any
}

export default observer(function AccordionOverviewCard({accordion, image}: AccordionOverviewCardProps){
    const navigate = useNavigate();
    const [checked, setChecked] = useState<boolean>(false);
    const theme = useTheme();
    const { currentLanguageMessages } = useStore().LanguageStore

    useEffect(() => {
        setChecked(true);
    }, []);

    const handleClick = () => {
        navigate(`/Accordions/${accordion.id}`)
    }

    return (
        <Fade in={checked} timeout={500}>
            <Box display={'flex'} justifyContent={'center'}>
                <Card
                    sx={{
                        width:260,
                        height: 260,
                        textAlign: 'center',
                        justifyContent: 'center',
                        pt: 2,
                        backgroundColor: (accordion.status === EntityStatus.draft) ? theme.palette.grey["200"] : null,
                    }}
                    elevation={3}
                    className={'accordionCard'}
                    onClick={handleClick}
                >
                    <Box sx={{display: 'flex', justifyContent: 'space-between', ml: 2, mr: 2}}>
                        <IconWithTooltip
                            Icon={(accordion.rental) ? ShareIcon : ShoppingBagOutlinedIcon }
                            text={
                                (accordion.rental) ?
                                    currentLanguageMessages.ShopShortcut.rent :
                                    currentLanguageMessages.ShopShortcut.buy
                            }
                            color={'info'}
                        />
                        <BrandIcon brand={accordion.brand} style={{height: '24px', width: '24px'}} />
                    </Box>
                    <CardMedia
                        sx={{height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
                    >
                        {
                            (accordion.thumbnail) ?
                                <img
                                    style={{width: 150, borderRadius: '20px', maxHeight: 150, objectFit: 'cover', objectPosition: 'center' }}
                                    src={accordion.thumbnail.data} alt={accordion.thumbnail.name}
                                /> :
                                <img style={{width: 150}} src={image} alt={'accordion-image'} />
                        }
                    </CardMedia>
                    <CardContent>
                        <Typography sx={{height: 30}}>{accordion.name}</Typography>
                        { accordion.status === EntityStatus.draft && <Chip label={'Draft'} color={'secondary'} icon={<ModeEditIcon />} /> }
                    </CardContent>
                </Card>
            </Box>
        </Fade>
    )
})